export * from "./i-crud-operation";
export * from "./i-data-access-event";
export * from "./i-data-change-callback-event";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_entities/data/index.ts